import { useEffect, useState } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { label: 'Our Team', href: '#team' },
    { label: 'Commitment', href: '#commitment' },
    { label: 'Evidence', href: '#evidence' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-40 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-[#1a1a1a]/8'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 cursor-pointer">
          <span
            className="text-[#1a1a1a] text-lg md:text-xl tracking-[0.2em] font-light"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            TEVANASHI
          </span>
          <span className="hidden sm:block text-[10px] text-[#b4a078] tracking-widest font-light mt-0.5">
            THE ALL-STAR PARTNER
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-[#1a1a1a]/60 hover:text-[#1a1a1a] text-xs tracking-[0.2em] uppercase transition-colors duration-300 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <a
          href="#cta"
          className="hidden md:flex items-center gap-2 border border-[#b4a078]/60 hover:border-[#b4a078] text-[#b4a078] hover:bg-[#b4a078]/8 text-xs tracking-[0.15em] px-5 py-2.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          無料相談
        </a>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <span className={`block w-5 h-px bg-[#1a1a1a] transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-5 h-px bg-[#1a1a1a] transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-5 h-px bg-[#1a1a1a] transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-white/98 backdrop-blur-md transition-all duration-400 overflow-hidden ${
          menuOpen ? 'max-h-64 border-b border-[#1a1a1a]/8' : 'max-h-0'
        }`}
      >
        <div className="px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-[#1a1a1a]/60 hover:text-[#1a1a1a] text-xs tracking-[0.2em] uppercase transition-colors duration-300 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#cta"
            onClick={() => setMenuOpen(false)}
            className="border border-[#b4a078]/60 text-[#b4a078] text-xs tracking-[0.15em] px-5 py-2.5 rounded-full text-center cursor-pointer whitespace-nowrap"
          >
            無料相談
          </a>
        </div>
      </div>
    </nav>
  );
}
